import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  display: flex;\n  align-items: center;\n  ", "\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
import { INPUT_HEIGHT, INPUT_ICON_LEFT_PADDING } from '../../Input/constants';
import { height } from '../../style/height';
import { paddingLeft } from '../../style/padding-left';
var FormIconWrapper = styled.div(_templateObject(), paddingLeft(INPUT_ICON_LEFT_PADDING), height(INPUT_HEIGHT));
export default FormIconWrapper;